module.exports = __webpack_public_path__ + "media/images/emblems/Oberdiessbach-coat_of_arms-56b3d69b162c5a302c98b5e95c92ebe6.svg";